import { axios } from '~/common/utils/request'
const commonPath = 'rest/erp/general/v3/'

// 列表
export const getRuleList = params => axios({
  url: `${commonPath}rule_parameters/query`,
  method: 'post',
  data: params
})

// 详情
export const getRuleDetail = id => axios({
  url: `${commonPath}rule_parameters/detail/${id}`,
  method: 'get'
})

// 新增
export const addRule = params => axios({
  url: `${commonPath}rule_parameters/create`,
  method: 'post',
  data: params
})
// 编辑
export const updateRule = params => axios({
  url: `${commonPath}rule_parameters/update`,
  method: 'post',
  data: params
})

// 激活/归档
export const activeRule = params => axios({
  url: `${commonPath}rule_parameters/active`,
  method: 'patch',
  data: params
})


